import styled from "styled-components"

import { maxWidth, when, eq, transparentize } from "utils"

import CloudinaryImage from "components/cloudinary-image"

export const Container = styled.section`
  display: ${({ hideOnPageLoad }) => (hideOnPageLoad ? "none" : "flex")};
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 6.3rem 0;
  color: ${({ theme }) => theme.component.text};
  background-color: ${({ theme }) => theme.component.background};

  ${eq("variant", "slim")`
    padding: 3.3rem 0;
  `}

  ${when("minHeight")`
    min-height: ${({ minHeight }) => minHeight}px;
  `}
`

export const Content = styled.div`
  max-width: 55%;
  text-align: center;
  position: relative;

  h3 {
    font-size: 1.4rem;
    letter-spacing: 0.2rem;
    text-transform: uppercase;
    margin-bottom: 2.5rem;

    ${eq("variant", "slim")`
      margin-bottom: 1.5rem;
    `}
  }

  h1 {
    font-size: 4.2rem;
    ${eq("variant", "slim")`
      font-size: 3.2rem;
    `}
  }

  > div > p {
    font-size: 2.6rem;
    margin: 1.5rem 0 0 0;

    ${eq("variant", "slim")`
      font-size: 2.4rem;
    `}
  }

  button {
    margin: 2.3rem auto 0 auto;
  }

  ${maxWidth.desktopL`
    max-width: 80%;
  `}

  ${maxWidth.tablet`
    max-width: 90%;
  `}
`

export const BackgroundImage = styled(CloudinaryImage)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: ${({ theme }) => {
    const bg = theme.component.background
    return `linear-gradient(90deg, ${transparentize(1.0, bg)} 0%, ${transparentize(
      0.85,
      bg,
    )} 13%, ${transparentize(0.25, bg)} 35%, ${transparentize(0.2, bg)} 50%, ${transparentize(
      0.25,
      bg,
    )} 64%, ${transparentize(0.85, bg)} 87%, ${transparentize(1.0, bg)} 100%)`
  }};
`

export const ButtonsContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;

  > :first-child {
    margin-right: 1.5rem;
  }

  > :last-child {
    margin-left: 1.5rem;
  }

  ${maxWidth.tablet`
    flex-direction: column;
    align-items: center;

    > :first-child,
    > :last-child {
      margin-left: 0;
      margin-right: 0;
    }
  `}
`
